import { ArrowLeft, Menu } from "lucide-react";
import styles from "./SubpageHeader.module.css";

interface SubpageHeaderProps {
  eyebrow: string;
  title: string;
  onBack: () => void;
  onMenuOpen: (trigger: HTMLButtonElement) => void;
}

export function SubpageHeader({
  eyebrow,
  title,
  onBack,
  onMenuOpen,
}: SubpageHeaderProps) {
  return (
    <header className={styles.header}>
      <button
        className={styles.iconButton}
        type="button"
        aria-label="Gå tillbaka"
        onClick={onBack}
      >
        <ArrowLeft aria-hidden="true" />
      </button>

      <div className={styles.title}>
        <span>{eyebrow}</span>
        <strong>{title}</strong>
      </div>

      <button
        className={styles.iconButton}
        type="button"
        aria-label="Öppna meny"
        aria-haspopup="dialog"
        onClick={(event) => onMenuOpen(event.currentTarget)}
      >
        <Menu aria-hidden="true" />
      </button>
    </header>
  );
}
